import React, { useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Checkbox, Dimmer, Icon, Loader, Modal, Search, Table, Popup, Image } from 'semantic-ui-react';
import { AppContext } from '../../context/app/appContext';
import _ from 'lodash'
import './Employee.css'
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import { TransactionTableList } from './TransactionTableList';
import { PerkTransactionTableList } from './PerkTransactionTableList'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { useParams, useHistory } from 'react-router-dom'

export const EmployeeDetails = (props) => {
    // const employee = props.employee;
    const [employee, setEmployee] = useState(null)

    const appContext = useContext(AppContext);
    const dimmer = 'blurring';
    const url = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    const accessToken = localStorage.getItem('accessToken');
    const history = useHistory();

    const [teamSelected, setTeamSelected] = useState('');

    const [cardTrigger, setCardTrigger] = useState(false) // Triggers re-fetching of card
    const [transactionTrigger, setTransactionTrigger] = useState(false) //Triggers refetching of transactions

    //Perks related stuff
    const [perkCard, setPerkCard] = useState(null);
    const [perkTransactions, setPerkTransactions] = useState(null);
    const [perkAmountSpent, setPerkAmountSpent] = useState(0);
    const [perkMockData, setPerkMockData] = useState([]);
    const [perksToDisplay, setPerksToDisplay] = useState([]);

    //Expenses related stuff
    const [expenseCard, setExpenseCard] = useState(null);
    const [expenseBudget, setExpenseBudget] = useState(0);
    const [expenseStatus, setExpenseStatus] = useState(null);
    const [expenseTransactions, setExpenseTransactions] = useState(null);
    const [expenseAmountSpent, setExpenseAmountSpent] = useState(0);
    const [shippingStatus, setShippingStatus] = useState(null)
    const [deliveryDate, setDeliveryDate] = useState('')
    const [expensesToDisplay, setExpensesToDisplay] = useState([]);
    const [mockData, setMockData] = useState([]);

    const [transactionSelector, setTransactionSelector] = useState(false) // Toggle between perks and expenses
    const [currentSelection, setCurrentSelection] = useState('perk')
    const [checkCount, setCheckCount] = useState(0);
    const [allTransactionSelection, setAllTransactionSelection] = useState(false);
    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';

    //Search related stuff
    // const [source, setSource] = useState([]);
    const [perkSource, setPerkSource] = useState([]);
    const [expenseSource, setExpenseSource] = useState([]);
    // Replace the three below
    // const [searchResults, setSearchResults] = useState([]);
    // const [searchSelection, setSearchSelection] = useState(null);
    // const [searchState, setSearchState] = useState('notSearching');
    // Convert above three to these
    const [perkSearchResults, setPerkSearchResults] = useState([]);
    const [expenseSearchResults, setExpenseSearchResults] = useState([]);
    const [perkSearchSelection, setPerkSearchSelection] = useState(null);
    const [expenseSearchSelection, setExpenseSearchSelection] = useState(null);
    const [perkSearchState, setPerkSearchState] = useState('notSearching');
    const [expenseSearchState, setExpenseSearchState] = useState('notSearching');

    const [isShipping, setIsShipping] = useState(false)
    const [isBilling, setIsBilling] = useState(false)

    const [ascending, setAscending] = useState(false);

    const [remainder, setRemainder] = useState(0); // Check remainder of transactions that cannot be flagged or requested
    const [selectedTransactions, setSelectedTransactions] = useState([]);
    const [apiSuccess, setApiSuccess] = useState(false);

    const [flagModal, setFlagModal] = useState(false);
    const [flagResponseModal, setFlagResponseModal] = useState(false);

    const [requestModal, setRequestModal] = useState(false);
    const [requestResponseModal, setRequestResponseModal] = useState(false);

    const [approveModal, setApproveModal] = useState(false);
    const [approveResponseModal, setApproveResponseModal] = useState(false);

    const [selectedReceipt, setSelectedReceipt] = useState(null) // To view receipt pdf
    const [receiptModal, setReceiptModal] = useState(false)
    const [receiptImages, setReceiptImages] = useState([]);

    const [deleteEmployeeModal, setDeleteEmployeeModal] = useState(false)

    const [receiptFailureModal, setReceiptFailureModal] = useState(false)

    const { id } = useParams()

    useEffect(() => {
        if (!appContext.teams.length) {
            (async function loadTeams() {
                await appContext.loadTeams();
            })();
        }
    }, []);

    useEffect(() => {
        if (!appContext.employees.length) {
            (async function loadTeams() {
                await appContext.setEmployees();
            })();
        }
    }, []);

    useEffect(() => {
        if (appContext.employees.length) {
            const currentEmployee = appContext.employees.filter(emp => { return emp.id === id })[0]
            setEmployee(currentEmployee)
            setExpenseStatus(currentEmployee != undefined ? currentEmployee.expenseStatus : null)
        }
    }, [appContext.employees, id])

    useEffect(() => {
        setSelectedTransactions([])
        if (transactionSelector) {
            setCurrentSelection('expense')
        } else {
            setCurrentSelection('perk')
        }
    }, [transactionSelector])

    useEffect(() => {
        if (allTransactionSelection) selectedAllTransactions(true);
        if (!allTransactionSelection) selectedAllTransactions(false);
    }, [allTransactionSelection]);

    function selectedAllTransactions(select = true) {
        if (transactionSelector) {
            if (expenseTransactions) {
                const allTransactionsSelected = expenseTransactions.map(transaction => {
                    return { ...transaction, selected: select };
                });
                setSelectedTransactions(allTransactionsSelected);
            }
        } else {
            if (perkTransactions) {
                const allTransactionsSelected = perkTransactions.map(transaction => {
                    return { ...transaction, selected: select };
                });
                setSelectedTransactions(allTransactionsSelected);
            }
        }
    }


    // Loads all employee cards
    useEffect(() => {
        (async function getCards() {
            if (employee !== undefined && appContext.teams.length) {
                appContext.setLoading();
                const team = appContext.teams.filter(team => { return team.id === employee.teamId })[0]
                setTeamSelected(team);
                setExpenseBudget(team ? team.expenseLimit : 0);

                (employee.status === 'active' && employee.shippingAddress.street &&
                    employee.shippingAddress.city &&
                    employee.shippingAddress.state &&
                    employee.shippingAddress.postalCode) ? setIsShipping(true) : setIsShipping(false);

                (employee.status === 'active' && employee.address && employee.city && employee.state &&
                    employee.postalCode) ? setIsBilling(true) : setIsBilling(false);

                console.log("Employee: ")
                console.info(employee)
                console.log(`card triggered ${cardTrigger}`);
                if (employee.status === 'active') {
                    await axios.post(url + '/employee/get-cards', { cardHolderId: employee.stripe.cardHolderId }, {
                        headers: {
                            Authorization: "Bearer " + accessToken
                        }
                    }).then(response => {
                        if ('cards' in response.data.data && response.data.data.cards.length > 0) {
                            const perk = response.data.data.cards.filter(card => { return card.metadata.card_type !== 'expense' })[0];
                            console.info({ perk })
                            setPerkCard(perk);
                            if ((employee.expenseStatus !== 'cardNotAssigned' && employee.expenseStatus !== 'none')) {
                                const expense = response.data.data.cards.filter(card => { return card.metadata.card_type === 'expense' })[0];
                                setExpenseCard(expense);
                                setShippingStatus(expense.shipping.status)
                                console.log('Card selected: ')
                                console.info({ expense })
                                var date = new Date(expense.shipping.eta * 1000);
                                setDeliveryDate(String(Number(date.getMonth()) + 1) + '/' + date.getDate() + '/' + date.getFullYear())
                                console.log('Expense Card Fetched')
                            }
                        }
                    }).catch(error => {
                        console.info(error.isAxiosError && error.message);
                    });
                }
                appContext.setLoading(false);
            }
        })();
    }, [appContext.teams, employee, expenseStatus, accessToken, url, cardTrigger]);


    //Loads perk transactions
    useEffect(() => {
        (async function loadPerkTransactions() {
            var today, listTransactions, perkSearch;
            console.log(`Current Selection ${currentSelection}`)
            if (perkCard && currentSelection === 'perk') {
                await axios.post(url + `/transaction/get`, { type: 'perk', userId: employee.id, cardId: perkCard.id }, {
                    headers: {
                        Authorization: "Bearer " + accessToken
                    }
                }).then(perk => {
                    if (perk.status === 200) {
                        perkSearch = []
                        setPerkAmountSpent(0);
                        if ('data' in perk.data && perk.data.data.transactionFetched.length > 0) {
                            listTransactions = []
                            today = new Date();
                            today.setDate(1)
                            perk.data.data.transactionFetched.forEach(transaction => {
                                listTransactions.push({ ...transaction, selected: false })
                                perkSearch.push(
                                    {
                                        id: transaction._id,
                                        title: transaction.merchantData.name + ", " + transaction.merchantData.city + ", " + transaction.merchantData.state,
                                        description: transaction.category[0],
                                    }
                                )
                                if (new Date(transaction.created) >= today) {
                                    setPerkAmountSpent(prev => prev + Math.abs(transaction.amount))
                                }
                            })
                            setPerkTransactions(listTransactions);
                            setPerkSource(perkSearch)
                            console.log('Perk transactions Fetched')
                        }
                    }
                })
            }
        })();
    }, [currentSelection, perkCard, url, employee, accessToken])


    // This renders every time perk transactions are fetched and ascending/descending is switched.
    useEffect(() => {
        let dat;
        let listTransactions;
        let date;
        let sectionKey;
        if (perkTransactions) {
            // appContext.setLoading();
            var sorted = perkTransactions.sort(function (a, b) {
                return !ascending ? (new Date(b.created) - new Date(a.created)) : (new Date(a.created) - new Date(b.created));
            });
            dat = {}
            _.each(sorted, function (item) {
                date = new Date(item.created)
                sectionKey = date.toLocaleString('default', { month: 'long' }) + " " + date.getFullYear();
                if (typeof dat[sectionKey] === "undefined") {
                    dat[sectionKey] = []
                }
                dat[sectionKey].push(
                    {
                        id: item._id,
                        date: date.getMonth()+1 + '/' + date.getDate() + '/' + date.getFullYear(),
                        merchant: item.merchantData.name + ", " + item.merchantData.city + ", " + item.merchantData.state,
                        category: item.category.map(cat => {if(cat.toLowerCase() !== 'popular') return cat.charAt(0).toUpperCase() + cat.slice(1)})[0],
                        amount: Math.abs(item.amount),
                        status: item.status,
                        // receipts: item.receipts,
                        // selected: item.selected ? item.selected : false,
                    }
                )
            })

            const transKeys = Object.keys(dat);
            console.log(transKeys)
            listTransactions = []
            transKeys.forEach(key => {
                listTransactions.push(
                    {
                        "section": key,
                        "data": dat[key]
                    }
                )
            })
            appContext.setLoading(false);
            setPerkMockData(listTransactions);
            setPerksToDisplay(listTransactions);
            console.info("Perk Mock Transaction Formatted");
            // console.info(listTransactions);
        }
    }, [perkTransactions, ascending,])


    useEffect(() => {
        let sorted;
        let dat;
        let listTransactions;
        let date;
        let sectionKey;
        let myArrayFiltered;
        console.log("Perks to display triggered")
        appContext.setLoading();

        if (perkSearchState === 'searchComplete' && currentSelection === 'perk') {
            if (perkSearchResults.length > 0) {
                myArrayFiltered = []
                console.info({ perkSearchResults })
                console.info({ perkSearchResults })
                perkSearchResults.forEach(result => {
                    var x = perkTransactions.filter(transaction => {
                        return transaction._id === result.id
                    })
                    if (x.length) {
                        myArrayFiltered.push(perkTransactions.filter(transaction => {
                            return transaction._id === result.id
                        })[0])
                    }
                    // myArrayFiltered.push(perkTransactions.filter(transaction => {
                    //     return transaction._id === result.id
                    // })[0])
                })
                console.log("hahahahah")
                console.log(myArrayFiltered)
                sorted = myArrayFiltered
                // .sort(function(a, b) {
                //     return !ascending ? new Date(b.created) - new Date(a.created) : new Date(a.created) - new Date(b.created);
                // });
                dat = {}
                _.each(sorted, function (item) {
                    date = new Date(item.created)
                    sectionKey = date.toLocaleString('default', { month: 'long' }) + " " + date.getFullYear();
                    if (typeof dat[sectionKey] === "undefined") {
                        dat[sectionKey] = []
                    }
                    dat[sectionKey].push(
                        {
                            id: item._id,
                            date: date.getMonth()+1 + '/' + date.getDate() + '/' + date.getFullYear(),
                            merchant: item.merchantData.name + ", " + item.merchantData.city + ", " + item.merchantData.state,
                            category: item.category[0],
                            amount: Math.abs(item.amount),
                            status: item.status,
                            // receipts: item.receipts,
                            selected: item.selected ? item.selected : false,
                            // perkSearchActive: false,
                        }
                    )
                })
                const transKeys = Object.keys(dat);
                listTransactions = []
                transKeys.forEach(key => {
                    listTransactions.push(
                        {
                            "section": key,
                            "data": dat[key]
                        }
                    )
                })
                setPerksToDisplay(listTransactions);
                console.log('Searching now')
            }
        }
        if (perkSearchState === 'itemSelected' && currentSelection === 'perk') {
            if (perkSearchSelection) {
                sorted = perkTransactions.filter(transaction => {
                    return transaction._id === perkSearchSelection;
                })
                dat = {}
                _.each(sorted, function (item) {
                    date = new Date(item.created)
                    sectionKey = date.toLocaleString('default', { month: 'long' }) + " " + date.getFullYear();
                    if (typeof dat[sectionKey] === "undefined") {
                        dat[sectionKey] = []
                    }
                    dat[sectionKey].push(
                        {
                            id: item._id,
                            date: date.getMonth()+1 + '/' + date.getDate() + '/' + date.getFullYear(),
                            merchant: item.merchantData.name + ", " + item.merchantData.city + ", " + item.merchantData.state,
                            category: item.category[0],
                            amount: Math.abs(item.amount),
                            status: item.status,
                            // receipts: item.receipts,
                            selected: item.selected ? item.selected : false,
                        }
                    )
                })
                const transKeys = Object.keys(dat);
                listTransactions = []
                transKeys.forEach(key => {
                    listTransactions.push(
                        {
                            "section": key,
                            "data": dat[key]
                        }
                    )
                })
                setPerksToDisplay(listTransactions);
                console.log('Selected perkSearch')
            }
        }
        if (perkSearchState === 'notSearching' && currentSelection === 'perk') {
            setPerksToDisplay(perkMockData)
        }
        appContext.setLoading(false);
    }, [perkSearchState, perkSearchResults, perkSearchSelection, perkTransactions, perkMockData, currentSelection])

    //Loads Expense Transactions
    useEffect(() => {
        (async function loadMockTransactions() {
            let today;
            let listTransactions;
            let expenseSearch;
            appContext.setLoading();
            console.log(`Transaction triggered ${transactionTrigger}`)
            console.log(`Current Selection ${currentSelection}`)
            if (expenseCard && currentSelection === 'expense') {
                await axios.post(url + `/transaction/get`, { type: 'expense', userId: employee.id, cardId: expenseCard.id }, {
                    headers: {
                        Authorization: "Bearer " + accessToken
                    }
                })
                    .then(expense => {
                        if (expense.status === 200) {
                            expenseSearch = [];
                            setExpenseAmountSpent(0)
                            if ('data' in expense.data && expense.data.data.transactionFetched.length > 0) {
                                listTransactions = []
                                today = new Date();
                                const expenseCardCreated = new Date(expenseCard.created)
                                const transactionPeriodStart = new Date(today.getFullYear(), today.getMonth(), expenseCardCreated.getDate());
                                if (expenseCardCreated.getDate() > today.getDate()) {
                                    transactionPeriodStart.setMonth(transactionPeriodStart.getMonth() - 1);
                                }
                                expense.data.data.transactionFetched.forEach(transaction => {
                                    listTransactions.push({ ...transaction, selected: false })
                                    expenseSearch.push(
                                        {
                                            id: transaction._id,
                                            title: transaction.merchantData.name + ", " + transaction.merchantData.city + ", " + transaction.merchantData.state,
                                            description: transaction.category[0],
                                        }
                                    )
                                    if (new Date(transaction.created) >= transactionPeriodStart) {
                                        setExpenseAmountSpent(prev => prev + Math.abs(transaction.amount))
                                    }
                                })
                                setExpenseTransactions(listTransactions);
                                setExpenseSource(expenseSearch)
                                console.log('Expense transactions Fetched')
                            }
                        }
                    })
                    .catch(error => {
                        console.info(error.isAxiosError && error.message);
                    });
            }
            appContext.setLoading(false);
        })();
    }, [expenseCard, employee, url, accessToken, transactionTrigger, currentSelection]);

    // This renders every time expense transactions are fetched and ascending/descending is switched.
    useEffect(() => {
        let dat;
        let listTransactions;
        let date;
        let sectionKey;
        if (expenseTransactions) {
            appContext.setLoading();
            var sorted = expenseTransactions.sort(function (a, b) {
                return !ascending ? (new Date(b.created) - new Date(a.created)) : (new Date(a.created) - new Date(b.created));
            });
            dat = {}
            _.each(sorted, function (item) {
                date = new Date(item.created)
                sectionKey = date.toLocaleString('default', { month: 'long' }) + " " + date.getFullYear();
                if (typeof dat[sectionKey] === "undefined") {
                    dat[sectionKey] = []
                }
                dat[sectionKey].push(
                    {
                        id: item._id,
                        date: date.getMonth()+1 + '/' + date.getDate() + '/' + date.getFullYear(),
                        merchant: item.merchantData.name + ", " + item.merchantData.city + ", " + item.merchantData.state,
                        category: item.category[0],
                        amount: Math.abs(item.amount),
                        status: item.status,
                        receipts: item.receipts,
                        receiptStatus: item.receiptStatus,
                        selected: item.selected ? item.selected : false,
                    }
                )
            })

            const transKeys = Object.keys(dat);
            console.log(transKeys)
            listTransactions = []
            transKeys.forEach(key => {
                listTransactions.push(
                    {
                        "section": key,
                        "data": dat[key]
                    }
                )
            })
            appContext.setLoading(false);
            setMockData(listTransactions);
            setExpensesToDisplay(listTransactions);
            console.info("Expense Mock Transaction Formatted");
            // console.info(listTransactions);
        }
    }, [expenseTransactions, ascending,])

    useEffect(() => {
        let sorted;
        let dat;
        let listTransactions;
        let date;
        let sectionKey;
        let myArrayFiltered;
        console.log("Expenses to display triggered")
        appContext.setLoading();
        if (expenseSearchState === 'searchComplete' && currentSelection === 'expense') {
            if (expenseSearchResults.length > 0) {
                myArrayFiltered = []
                expenseSearchResults.forEach(result => {
                    var x = expenseTransactions.filter(transaction => {
                        return transaction._id === result.id
                    })
                    if (x.length) {
                        myArrayFiltered.push(expenseTransactions.filter(transaction => {
                            return transaction._id === result.id
                        })[0])
                    }
                })
                console.log(myArrayFiltered)
                sorted = myArrayFiltered
                // .sort(function(a, b) {
                //     return !ascending ? new Date(b.created) - new Date(a.created) : new Date(a.created) - new Date(b.created);
                // });
                dat = {}
                _.each(sorted, function (item) {
                    date = new Date(item.created)
                    sectionKey = date.toLocaleString('default', { month: 'long' }) + " " + date.getFullYear();
                    if (typeof dat[sectionKey] === "undefined") {
                        dat[sectionKey] = []
                    }
                    dat[sectionKey].push(
                        {
                            id: item._id,
                            date: date.getMonth()+1 + '/' + date.getDate() + '/' + date.getFullYear(),
                            merchant: item.merchantData.name + ", " + item.merchantData.city + ", " + item.merchantData.state,
                            category: item.category[0],
                            amount: Math.abs(item.amount),
                            status: item.status,
                            receipts: item.receipts,
                            receiptStatus: item.receiptStatus,
                            selected: item.selected ? item.selected : false,
                            // expenseSearchActive: false,
                        }
                    )
                })
                const transKeys = Object.keys(dat);
                listTransactions = []
                transKeys.forEach(key => {
                    listTransactions.push(
                        {
                            "section": key,
                            "data": dat[key]
                        }
                    )
                })
                setExpensesToDisplay(listTransactions);
                console.log('Searching now')
            }
        }
        if (expenseSearchState === 'itemSelected' && currentSelection === 'expense') {
            if (expenseSearchSelection) {
                sorted = expenseTransactions.filter(transaction => {
                    return transaction._id === expenseSearchSelection;
                })
                dat = {}
                _.each(sorted, function (item) {
                    date = new Date(item.created)
                    sectionKey = date.toLocaleString('default', { month: 'long' }) + " " + date.getFullYear();
                    if (typeof dat[sectionKey] === "undefined") {
                        dat[sectionKey] = []
                    }
                    dat[sectionKey].push(
                        {
                            id: item._id,
                            date: date.getMonth()+1 + '/' + date.getDate() + '/' + date.getFullYear(),
                            merchant: item.merchantData.name + ", " + item.merchantData.city + ", " + item.merchantData.state,
                            category: item.category[0],
                            amount: Math.abs(item.amount),
                            status: item.status,
                            receipts: item.receipts,
                            receiptStatus: item.receiptStatus,
                            selected: item.selected ? item.selected : false,
                        }
                    )
                })
                const transKeys = Object.keys(dat);
                listTransactions = []
                transKeys.forEach(key => {
                    listTransactions.push(
                        {
                            "section": key,
                            "data": dat[key]
                        }
                    )
                })
                setExpensesToDisplay(listTransactions);
                console.log('Selected expenseSearch')
            }
        }
        if (expenseSearchState === 'notSearching' && currentSelection === 'expense') {
            setExpensesToDisplay(mockData)
        }
        appContext.setLoading(false);
    }, [expenseSearchState, expenseSearchResults, expenseSearchSelection, expenseTransactions, mockData, currentSelection])

    //##############################################################################################################################################

    const handleTransactionSelectionChange = (id, selected, section) => {
        var tempMockExpenseData = mockData;
        if (transactionSelector) {
            const mockIndex = tempMockExpenseData.findIndex(obj => obj.section === section);
            const mockTransIndex = tempMockExpenseData[mockIndex].data.findIndex(obj => obj.id === id);
            console.log(mockIndex + " " + mockTransIndex)
            if (!selected) {
                setCheckCount(prev => prev + 1)
                tempMockExpenseData[mockIndex].data[mockTransIndex].selected = true
            } else {
                setCheckCount(prev => prev - 1)
                tempMockExpenseData[mockIndex].data[mockTransIndex].selected = false
            }
            setMockData(tempMockExpenseData);
        } else {
            const mockIndex = tempMockExpenseData.findIndex(obj => obj.section === section);
            const mockTransIndex = tempMockExpenseData[mockIndex].data.findIndex(obj => obj.id === id);
            console.log(mockIndex + " " + mockTransIndex)
            if (!selected) {
                setCheckCount(prev => prev + 1)
                tempMockExpenseData[mockIndex].data[mockTransIndex].selected = true
            } else {
                setCheckCount(prev => prev - 1)
                tempMockExpenseData[mockIndex].data[mockTransIndex].selected = false
            }
            setMockData(tempMockExpenseData);
        }
    };


    const initialState1 = {
        loading: false,
        results: [],
        value: '',
        step: 'notSearching'
    }

    function exampleReducer1(state, action) {
        switch (action.type) {
            case 'CLEAN_QUERY':
                return initialState1
            case 'START_SEARCH':
                return { ...state, loading: true, value: action.query }
            case 'FINISH_SEARCH':
                return { ...state, loading: false, results: action.results, step: 'searchComplete' }
            case 'UPDATE_SELECTION':
                return { ...state, value: action.selection, step: 'itemSelected' }

            default:
                throw new Error()
        }
    }

    function SearchExampleStandard1(sourceData) {
        console.log("Perks search")
        const [state, dispatch] = React.useReducer(exampleReducer, initialState)
        const { loading, results, value, step } = state

        const timeoutRef = React.useRef();

        const handleSearchChange = React.useCallback((e, data) => {
            clearTimeout(timeoutRef.current)
            dispatch({ type: 'START_SEARCH', query: data.value })

            timeoutRef.current = setTimeout(() => {
                if (data.value.length === 0) {
                    setPerkSearchState('notSearching')
                    dispatch({ type: 'CLEAN_QUERY' })
                    return
                }

                const re = new RegExp(_.escapeRegExp(data.value), 'i')
                const isMatch = (result) => re.test(result.title) || re.test(result.description)

                dispatch({
                    type: 'FINISH_SEARCH',
                    results: _.filter(sourceData, isMatch),
                })

            }, 300)
        }, [sourceData])

        useEffect(() => {
            if (step === "searchComplete") {
                setPerkSearchState('searchComplete');
                setPerkSearchResults(results);
            }
            else if (step === "itemSelected") {
                setPerkSearchState('itemSelected');
                setPerkSearchSelection(value.id);
            }
            else {
                setPerkSearchResults([]);
            }
        }, [step, results, value])

        React.useEffect(() => {
            return () => {
                clearTimeout(timeoutRef.current)
            }
        }, [])
        return (
            <div>
                {!transactionSelector ?
                    <Search
                        loading={loading}
                        input={{ fluid: true }}
                        onResultSelect={(e, data) =>
                            dispatch({ type: 'UPDATE_SELECTION', selection: data.result })
                        }
                        onSearchChange={handleSearchChange}
                        results={results}
                        value={value.title}
                        size='medium'
                        // width={'200%'}
                        // style={{width:'200%'}}
                        fluid
                    />
                    : null}
            </div>
        )
    }


    const initialState = {
        loading: false,
        results: [],
        value: '',
        step: 'notSearching'
    }

    function exampleReducer(state, action) {
        switch (action.type) {
            case 'CLEAN_QUERY':
                return initialState
            case 'START_SEARCH':
                return { ...state, loading: true, value: action.query }
            case 'FINISH_SEARCH':
                return { ...state, loading: false, results: action.results, step: 'searchComplete' }
            case 'UPDATE_SELECTION':
                return { ...state, value: action.selection, step: 'itemSelected' }

            default:
                throw new Error()
        }
    }

    function SearchExampleStandard(sourceData) {
        console.log("Expenses search")
        const [state, dispatch] = React.useReducer(exampleReducer, initialState)
        const { loading, results, value, step } = state

        const timeoutRef = React.useRef();

        const handleSearchChange = React.useCallback((e, data) => {
            clearTimeout(timeoutRef.current)
            dispatch({ type: 'START_SEARCH', query: data.value })

            timeoutRef.current = setTimeout(() => {
                if (data.value.length === 0) {
                    setExpenseSearchState('notSearching')
                    dispatch({ type: 'CLEAN_QUERY' })
                    return
                }

                const re = new RegExp(_.escapeRegExp(data.value), 'i')
                const isMatch = (result) => re.test(result.title) || re.test(result.description)

                dispatch({
                    type: 'FINISH_SEARCH',
                    results: _.filter(sourceData, isMatch),
                })

            }, 300)
        }, [sourceData])

        useEffect(() => {
            if (step === "searchComplete") {
                setExpenseSearchState('searchComplete');
                setExpenseSearchResults(results);
            }
            else if (step === "itemSelected") {
                setExpenseSearchState('itemSelected');
                setExpenseSearchSelection(value.id);
            }
            else {
                setExpenseSearchResults([]);
            }
        }, [step, results, value])

        React.useEffect(() => {
            return () => {
                clearTimeout(timeoutRef.current)
            }
        }, [])
        return (
            <div>
                {transactionSelector ?
                    <Search
                        loading={loading}
                        input={{ fluid: true }}
                        onResultSelect={(e, data) =>
                            dispatch({ type: 'UPDATE_SELECTION', selection: data.result })
                        }
                        onSearchChange={handleSearchChange}
                        results={results}
                        value={value.title}
                        size='medium'
                        // width={'200%'}
                        // style={{width:'200%'}}
                        fluid
                    />
                    : null}
            </div>
        )
    }

    const flagTransactions = () => {
        // const selectTransactions = expenseTransactions.filter(transaction => {
        //     return transaction.selected
        // })
        const selectTransactions = mockData.map(obj => {
            return obj.data.filter(obj1 => { return obj1.selected })
        }).flat()
        console.log("========")
        console.log(selectTransactions)
        const allowedTransactions = selectTransactions.filter(transaction => {
            return transaction.status === 'uploadedEmployee'
        })
        const remainder = selectTransactions.length - allowedTransactions.length;
        setSelectedTransactions(allowedTransactions);
        // setAllowedFlag(allowedTransactions.length)
        setRemainder(remainder);
        setFlagModal(true);
    }

    const flagModalCloseHandler = () => {
        setSelectedTransactions([]);
        setFlagModal(false);
        if (flagResponseModal && apiSuccess && !remainder) {
            setTransactionTrigger(prev => !prev)
            setSelectedTransactions([])
            setCheckCount(0)
        }
        setFlagResponseModal(false);
    }

    const flagModalConfirmHandler = async () => {
        setFlagModal(false);
        if (selectedTransactions.length) {
            await axios.post(url + '/transaction/receipt/flag',
                { id: selectedTransactions.map(transaction => { return transaction.id }), userId: employee.id }, {
                headers: {
                    Authorization: "Bearer " + accessToken
                }
            }).then(response => {
                if (response.status === 200) {
                    setApiSuccess(true);
                } else {
                    setApiSuccess(false);
                }
                setFlagResponseModal(true);
            }).catch(error => {
                console.log(error);
                setApiSuccess(false);
                setFlagResponseModal(true);
            })
        } else {
            setApiSuccess(true);
            setFlagResponseModal(true);
        }
    }

    const onReceiptRequest = () => {
        // const selectTransactions = expenseTransactions.filter(transaction => {
        //     return transaction.selected
        // })
        const selectTransactions = mockData.map(obj => {
            return obj.data.filter(obj1 => { return obj1.selected })
        }).flat()
        const allowedTransactions = selectTransactions.filter(transaction => {
            return transaction.receiptStatus === 'notUpdated'
        })
        const remainder = selectTransactions.length - allowedTransactions.length;
        setSelectedTransactions(allowedTransactions);
        // setAllowedFlag(allowedTransactions.length)
        setRemainder(remainder);
        setRequestModal(true);
    }

    const requestModalCloseHandler = () => {
        setSelectedTransactions([]);
        setRequestModal(false);
        if (requestResponseModal && apiSuccess && !remainder) {
            setTransactionTrigger(prev => !prev)
            setSelectedTransactions([])
            setCheckCount(0)
        }
        setRequestResponseModal(false);
    }

    const requestModalConfirmHandler = async () => {
        setRequestModal(false);

        if (selectedTransactions.length) {
            await axios.post(url + '/transaction/receipt/request',
                { id: selectedTransactions.map(transaction => { return transaction.id }), userId: employee.id }, {
                headers: {
                    Authorization: "Bearer " + accessToken
                }
            }).then(response => {
                if (response.status === 200) {
                    console.log("hereeeeeeee")
                    setApiSuccess(true);
                    // setTransactionTrigger(prev => !prev)
                } else {
                    setApiSuccess(false);
                }
                setRequestResponseModal(true);
            }).catch(error => {
                console.log(error);
                setApiSuccess(false);
                setRequestResponseModal(true);
            })
        } else {
            setApiSuccess(true);
            setRequestResponseModal(true);
        }
    }

    const approveTransactions = () => {
        const selectTransactions = mockData.map(obj => {
            return obj.data.filter(obj1 => { return obj1.selected })
        }).flat()
        const allowedTransactions = selectTransactions.filter(transaction => {
            return transaction.receiptStatus !== 'approved'
        })
        const remainder = selectTransactions.length - allowedTransactions.length;
        setSelectedTransactions(allowedTransactions);
        // setAllowedFlag(allowedTransactions.length)
        setRemainder(remainder);
        setApproveModal(true);
    }

    const approveModalCloseHandler = () => {
        setSelectedTransactions([]);
        setApproveModal(false);
        if (approveResponseModal && apiSuccess && !remainder) {
            setTransactionTrigger(prev => !prev)
            setSelectedTransactions([])
            setCheckCount(0)
        }
        setApproveResponseModal(false);
    }

    const approveModalConfirmHandler = async () => {
        setApproveModal(false);
        if (selectedTransactions.length) {
            await axios.post(url + '/transaction/receipt/approve',
                { id: selectedTransactions.map(transaction => { return transaction.id }), userId: employee.id }, {
                headers: {
                    Authorization: "Bearer " + accessToken
                }
            }).then(response => {
                if (response.status === 200) {
                    setApiSuccess(true);
                    // setTransactionTrigger(prev => !prev)
                } else {
                    setApiSuccess(false);
                }
                setApproveResponseModal(true);
            }).catch(error => {
                console.log(error);
                setApiSuccess(false);
                setApproveResponseModal(true);
            })
        } else {
            setApiSuccess(true);
            setApproveResponseModal(true);
        }
    }

    // const onReceiptModalConfirm = async (e) => {
    //     e.preventDefault();
    //     setReceiptRequest(false);
    //     setReceiptModalClose(true);
    // }

    async function shipCard(event, data) {
        console.log(event);
        console.log(data);
        var expenseCardCreated;
        // var expenseProgram;
        // var stripeCategoriesList = []
        // var temp;
        if (teamSelected.expenseProgramId.length > 0) {

            await axios.post(url + '/create-expense-card', {
                shipping: employee.shippingAddress,
                teamId: employee.teamId,
                id: employee.id,
                // spendingControls: stripeCategoriesList,
                cardHolderId: employee.stripe.cardHolderId,
                firstName: employee.firstName,
                lastName: employee.lastName
            }, {
                headers: {
                    Authorization: "Bearer " + accessToken
                }
            }).then(response => {
                console.log(response)
                if (response.status === 200) {
                    if (response.data && response.data.data) {
                        expenseCardCreated = response.data.data;
                        console.info({ expenseCardCreated })
                        employee.expenseStatus = 'activateHR'
                        setCardTrigger(prev => !prev)
                        setExpenseStatus('activateHR')
                        setShippingStatus('pending')
                    }
                }
            })
                .catch(error => {
                    console.info(error.isAxiosError && error.message);
                });
        }
    }

    async function freezeCard(event) {
        console.log(event)
        await axios.post(url + `/freeze-expense-card`, {
            teamId: employee.teamId,
            id: employee.id,
            cardId: expenseCard.id,
        }, {
            headers: {
                Authorization: "Bearer " + accessToken
            }
        })
            .then(response => {
                console.log("Freeze card response: " + response);
                if (response.status === 200) {

                    sendFreezeAction()
                    employee.expenseStatus = 'freeze'
                    setExpenseStatus('freeze')
                }
            })
            .catch(error => {
                console.info(error.isAxiosError && error.message);
            });
    }

    async function activateCard(event) {
        console.log(event)
        await axios.post(url + `/activate-expense-card`, {
            teamId: employee.teamId,
            id: employee.id,
            cardId: expenseCard.id,
        }, {
            headers: {
                Authorization: "Bearer " + accessToken
            }
        })
            .then(response => {
                console.log("Activate Card Response: " + response);
                if (response.status === 200) {
                    sendActivateAction()
                    employee.expenseStatus = 'activateEmployee'
                    setExpenseStatus('activateEmployee')
                }
            })
            .catch(error => {
                console.info(error.isAxiosError && error.message);
            });
    }
    const sendActivateAction = async () => {
        await axios.post(baseURL + '/recentActions', { task: 'Expense Card Activated: ' + employee.name }, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem('accessToken')
            }
        })
    }
    const sendFreezeAction = async () => {
        await axios.post(baseURL + '/recentActions', { task: 'Expense Card Frozen: ' + employee.name }, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem('accessToken')
            }
        })
    }

    function buttonClicked(event) {
        console.log(event);
        if (expenseStatus === 'activateEmployee') {
            freezeCard();
        } else if (expenseStatus === 'freeze') {
            activateCard();
        }
    }

    function deleteEmployee(event) {
        console.log(event);
        console.info("Id here: ", id)
        setDeleteEmployeeModal(true)
    }

    const confirmDeleteEmployee = async () => {
        appContext.deleteEmployee(id);
        await axios.post(baseURL + '/recentActions', { task: 'Employee ' + employee.name + ' deleted' }, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem('accessToken')
            }
        })
        history.goBack();
    }
    console.log("employee", employee)
    const handleReceiptClick = (transaction) => {
        console.log(transaction)
        setSelectedReceipt(transaction);
        var images = []
        transaction.receipts.forEach(receipt => {
            axios.post(url + '/transaction/receipt/get', { userId: employee.id, receiptName: receipt }, {
                headers: {
                    Authorization: "Bearer " + accessToken
                }
            }).then(response => {
                if (response.status === 200) {
                    // setReceiptImages(prev => prev.push(response.data));
                    images.push(response.data);
                    if (images.length === transaction.receipts.length) {
                        setApiSuccess(true)
                        setReceiptImages(images)
                        setReceiptModal(true)
                    } else {
                        setApiSuccess(false)
                        setReceiptModal(true)
                        // setReceiptFailureModal(true)
                    }
                } else {
                    setApiSuccess(false)
                    setReceiptModal(true)
                    // setReceiptFailureModal(true)
                }
                // setReceiptModal(true)
            }).catch(error => {
                setApiSuccess(false)
                setReceiptModal(true)
                // setReceiptFailureModal(true)
                console.log(error)
            })

        })
    }

    const receiptModalCloseHandler = () => {
        // setCurrentImageData(null);
        setReceiptModal(false)
        setApiSuccess(false)
        setReceiptImages([])
    }

    function sliderToggled(event, data) {
        // setPerkSearchState('notSearching')
        // setExpenseSearchState('notSearching')
        // setPerkSearchResults([])
        // setExpenseSearchResults([])
        // setPerkSearchSelection(null)
        // setExpenseSearchSelection(null)
        setTransactionSelector(data.checked);
    }

    const handleDateChevron = () => {
        var temp = ascending;
        setAscending(!temp);
    }

    return (
        <div>
            {employee ?
                <>
                    {/* --- page starts from here --- */}
                    <div id="employees-page" className="dashboard-page" style={{ width: '90vw' }}>
                        {appContext.loading && (<Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>) && teamSelected === ''}

                        {/* <header>
                    <h3>Employee Details</h3>
                </header> */}

                        <div className="sub-page" id="team-management" style={{ width: '90vw' }}>
                            <div className="ui segment" style={{ backgroundColor: 'transparent', marginRight: 0, paddingRight: 0, width: '90vw' }}>
                                <div style={{ fontSize: 28, fontStyle: 'SFProText-Bold', fontWeight: '900', letterSpacing: 1, paddingBottom: 10, marginTop: 5 }}>{employee.name}  Details</div>

                                {(employee.status === 'active' && teamSelected.budget > 0 ) ?
                                    <div className="ui secondary menu" style={{ display: 'flex', flex: 1, flexDirection: 'row', marginBottom: -10, paddingLeft: 15, marginRight: 15, fontStyle: 'SFProText-Regular' }}>
                                        <span style={{ fontSize: 18, flex: 1 }}>Perk Budget:</span><span style={{ fontSize: 18, flex: 0.8 }}>${teamSelected.budget}</span>
                                        <span style={{ fontSize: 18, flex: 0.7 }}>Available:</span><span style={{ fontSize: 18, flex: 0.8 }}>${teamSelected.budget - (perkAmountSpent / 100)}</span>
                                        <span style={{ fontSize: 18, flex: 0.5 }}>Spent:</span><span style={{ fontSize: 18, flex: 1 }}>${perkAmountSpent / 100}</span>
                                        <div style={{ fontSize: 18, flex: 1.5 }}>Perk Card Status: </div>
                                        <div style={{ color: 'green', fontSize: 18, flex: 2 }}>Active</div>
                                        <div className="item" style={{ flex: 1.5, marginTop: -20, justifyContent: 'flex-end', alignContent: 'center', paddingRight: '3%' }} >
                                            <Button
                                                style={{ color: 'red' }}
                                                // className="ui button"
                                                disabled = {employee && (employee.role === 'perk-manager' || employee.role === 'perk-manager-ft')}
                                                onClick={event => deleteEmployee(event)}>
                                                <Icon color={'red'} name='user delete' />
                                                Delete Employee
                                        </Button>
                                        </div>
                                    </div>
                                    :
                                    <div className="ui secondary menu" style={{ flex: 1, flexDirection: 'row', marginBottom: -10, paddingLeft: 15, marginRight: 15, fontStyle: 'SFProText-Regular' }}>
                                        <span style={{ fontSize: 18, flex: 1 }}>
                                            {/* {teamSelected.budget} {teamSelected.perkProgramId} */}
                                        Perk Card Status: {employee.status === 'inactive' ? 'Employee has not logged in on the App' : 'No Perk Program Attached'}
                                        </span>
                                        <div className="item" style={{ flex: 1.5, marginTop: -20, justifyContent: 'flex-end', alignContent: 'center', paddingRight: '3%'}} >
                                            <Button
                                                style={{ color: 'red' }}
                                                // className="ui button"
                                                disabled = {employee && (employee.role === 'perk-manager' || employee.role === 'perk-manager-ft')}
                                                onClick={event => deleteEmployee(event)}>
                                                <Icon color={'red'} name='user delete' />
                                                Delete Employee
                                        </Button>
                                        </div>
                                    </div>
                                }


                                {(employee.status === 'active') ?
                                    (isShipping) ?
                                        ((expenseBudget && expenseBudget > 0)) ?
                                            // ((teamSelected.expenseProgramId && teamSelected.expenseProgramId.length > 0)) ?
                                                (expenseStatus !== 'cardNotAssigned') ?
                                                    (shippingStatus === 'delivered' || shippingStatus === 'shipped') ?
                                                        (expenseStatus !== 'activateHR') ?
                                                            // (expenseCard.status === 'active') ?
                                                                <div className="ui secondary  menu" style={{ flex: 1, flexDirection: 'row', marginBottom: -10, paddingLeft: 15, marginRight: 15, fontStyle: 'SFProText-Regular' }}>
                                                                    <span style={{ fontSize: 18, flex: 1, verticalAlign: 'center' }}>Expense Limit:</span><span style={{ fontSize: 18, flex: 0.8 }}>${teamSelected.expenseLimit}</span>
                                                                    <span style={{ fontSize: 18, flex: 0.7 }}>Available:</span><span style={{ fontSize: 18, flex: 0.8 }}>${teamSelected.expenseLimit - expenseAmountSpent / 100}</span>
                                                                    <span style={{ fontSize: 18, flex: 0.5 }}>Spent:</span><span style={{ fontSize: 18, flex: 1 }}>${expenseAmountSpent / 100}</span>
                                                                    <div style={{ fontSize: 18, flex: 1.5 }}>Expense Card Status: </div>
                                                                    <div style={{ color: (expenseStatus === 'activateEmployee') ? 'green' : 'red', fontSize: 18, flex: 2 }}>{(expenseStatus === 'activateEmployee') ? 'Active' : 'Inactive'}</div>
                                                                    <div className="item" style={{ flex: 1.5, marginTop: -20, justifyContent: 'flex-end', alignContent: 'center', paddingRight: '3%' }} >
                                                                        <button
                                                                            style={{ color: !(expenseStatus === 'activateEmployee') ? 'green' : 'red', }}
                                                                            className="ui button"
                                                                            onClick={event => buttonClicked(event)}>
                                                                            <Icon color={!(expenseStatus === 'activateEmployee') ? 'green' : 'red'} name='power' />
                                                                            {(expenseStatus === 'activateEmployee') ? 'Freeze Card' : 'Activate Card'}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                // :
                                                                // <div className="ui secondary  menu" style={{ flex: 1, flexDirection: 'row', marginBottom: -10, paddingLeft: 15, marginRight: 15, fontStyle: 'SFProText-Regular' }}>
                                                                //     <div style={{ fontSize: 18, flex: 8.3 }}>Expense Status: Error Loading Expense Data.</div>
                                                                // </div>
                                                            :
                                                            <div className="ui secondary  menu" style={{ flex: 1, flexDirection: 'row', marginBottom: -10, paddingLeft: 15, marginRight: 15, fontStyle: 'SFProText-Regular' }}>
                                                                <div style={{ fontSize: 18, flex: 8.3 }}>Employee has not Activated the Expense Card.</div>
                                                            </div>
                                                        :
                                                        <div className="ui secondary  menu" style={{ flex: 1, flexDirection: 'row', marginBottom: -10, paddingLeft: 15, marginRight: 15, fontStyle: 'SFProText-Regular' }}>
                                                            <div style={{ fontSize: 18, flex: 8.3 }}>Expense Status: Expense Card is on its way.</div>
                                                        </div>
                                                    :
                                                    <div className="ui secondary  menu" style={{ flex: 1, flexDirection: 'row', marginBottom: -10, paddingLeft: 15, marginRight: 15, fontStyle: 'SFProText-Regular' }}>
                                                        <div style={{ fontSize: 18, flex: 8.3 }}>Expense Status: Expense Card has not been assigned yet.</div>
                                                        <div className="item" style={{ flex: 1.5, }} >
                                                            <button
                                                                style={{ color: 'green', marginBottom: 20 }}
                                                                className="ui button"
                                                                onClick={(event, data) => { shipCard(event, data) }}>
                                                                <Icon color='green' name='power' />
                                                                    Assign Card
                                                            </button>
                                                        </div>
                                                    </div>
                                                :
                                                <div className="ui secondary  menu" style={{ flex: 1, flexDirection: 'row', marginBottom: -10, paddingLeft: 15, marginRight: 15, fontStyle: 'SFProText-Regular' }}>
                                                    <div style={{ fontSize: 18, flex: 8.3 }}>Expense Status: No Expense Program linked.</div>
                                                </div>
                                            // :
                                            // <div className="ui secondary  menu" style={{ flex: 1, flexDirection: 'row', marginBottom: -10, paddingLeft: 15, marginRight: 15, fontStyle: 'SFProText-Regular' }}>
                                            //     <div style={{ fontSize: 18, flex: 8.3 }}>Expense Status: No Team Expense Budget. Please allocate Expense Budget first.</div>
                                            // </div>
                                        :
                                        <div className="ui secondary  menu" style={{ flex: 1, flexDirection: 'row', marginBottom: -10, paddingLeft: 15, marginRight: 15, fontStyle: 'SFProText-Regular' }}>
                                            <div style={{ fontSize: 18, flex: 8.3 }}>Expense Status: Employee has not provided Shipping Details.</div>
                                        </div>
                                    :
                                    <div className="ui secondary menu" style={{ flex: 1, flexDirection: 'row', marginBottom: -10, paddingLeft: 15, marginRight: 15, fontStyle: 'SFProText-Regular' }}>
                                        <span style={{ fontSize: 18, flex: 1 }}>
                                            {employee.status === 'inactive' ? 'Expense Status: Employee has not logged in on the App' : 'Expense Status: No Perk Program Attached'}
                                        </span>
                                    </div>
                                }

                                {(expenseBudget > 0 && expenseStatus === 'activateHR' && shippingStatus) ?
                                    <div className="" style={{ flex: 1, flexDirection: 'column', backgroundColor: 'transparent', borderWidth: 2, borderColor: 'rgba(69, 69, 69, 0.17)', marginRight: 15, marginTop: 10 }}>
                                        <div style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-around', paddingLeft: 10 }}>
                                            <span style={{ flex: 2 }}>
                                                Physical Card Status: {shippingStatus.charAt(0).toUpperCase() + shippingStatus.slice(1)}
                                            </span>
                                            <span style={{ flex: 1, marginLeft: '20%' }}>
                                                Estimated Arival Date: {deliveryDate}
                                            </span>
                                        </div>
                                        <div style={{ flex: 1, flexDirection: 'row', marginTop: 20, width: '95%', paddingLeft: '5%' }}>
                                            <ProgressBar percent={
                                                shippingStatus === 'pending' ? 0 : (shippingStatus === 'shipped' ? 50 : 100)
                                            }
                                                filledBackground={
                                                    shippingStatus === 'canceled' ? 'rgb(236, 221, 12)' : (shippingStatus === 'returned' ? 'rgb(217, 130, 0)' : (shippingStatus === 'failure' ? 'rgba(223, 21, 21, 0.979)' : 'rgba(0, 116, 217, 1)'))}>
                                                <Step>
                                                    {({ accomplished, index }) => (
                                                        <div
                                                            className={`indexedStep ${accomplished ? "accomplished" : null}`}
                                                        >
                                                            {index + 1}
                                                        </div>
                                                    )}
                                                </Step>
                                                <Step>
                                                    {({ accomplished, index }) => (
                                                        <div
                                                            className={`indexedStep ${accomplished ? "accomplished" : null}`}
                                                        >
                                                            {index + 1}
                                                        </div>
                                                    )}
                                                </Step>
                                                <Step>
                                                    {({ accomplished, index }) => (
                                                        <div
                                                            className={`indexedStep ${accomplished ? shippingStatus : null}`}
                                                        >
                                                            {index + 1}
                                                        </div>
                                                    )}
                                                </Step>
                                            </ProgressBar>
                                        </div>
                                        <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'stretch', marginTop: 10, width: '97%', paddingLeft: '3%' }}>
                                            <div style={{ display: 'flex', flex: 1 }}>
                                                Pending
                                        </div>
                                            <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
                                                Shipped
                                        </div>
                                            <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
                                                {shippingStatus !== 'pending' && shippingStatus !== 'shipped' ? shippingStatus.charAt(0).toUpperCase() + shippingStatus.slice(1) : 'Delivered'}
                                            </div>
                                        </div>
                                    </div>
                                    : null}
                            </div>

                            <div className="ui segment" style={{ width: '90vw', backgroundColor: 'transparent' }} >
                                <div style={{ fontSize: 24, letterSpacing: 0.5, marginTop: 5, marginBottom: 20, fontStyle: 'SFProText-Regular' }}>{transactionSelector ? 'Expenses' : 'Perks'} History</div>
                                <div className="ui secondary menu" style={{ display: 'flex', flex: 1, flexDirection: 'row', marginTop: 20, marginBottom: 0, paddingLeft: 10 }}>
                                    <div style={{ flex: 1.5, flexDirection: 'row', marginTop: 5 }}>
                                        {transactionSelector ?
                                            <Popup content='Request Receipts' trigger={
                                                <Icon name='file pdf' size='big' color={checkCount ? 'yellow' : 'grey'}
                                                    disabled={checkCount === 0}
                                                    onClick={(checkCount !== 0) ? onReceiptRequest : null}
                                                />
                                            } />
                                            :
                                            null
                                        }
                                        {transactionSelector ?
                                            <Popup content='Flag Transactions' style={{ paddingLeft: 5 }} trigger={
                                                <Icon name='exclamation circle' size='big' color={checkCount ? 'red' : 'grey'}
                                                    disabled={checkCount === 0}
                                                    onClick={(checkCount !== 0) ? flagTransactions : null}
                                                />
                                            } />
                                            :
                                            null
                                        }
                                        {transactionSelector ?
                                            <Popup content='Approve Transactions' style={{ paddingLeft: 5 }} trigger={
                                                <Icon name='check circle' size='big' color={checkCount ? 'green' : 'grey'}
                                                    disabled={checkCount === 0}
                                                    onClick={(checkCount !== 0) ? approveTransactions : null}
                                                />
                                            } />
                                            :
                                            null
                                        }
                                        <span style={{ paddingLeft: 20 }}>
                                            Perks
                                    </span>
                                        <Checkbox slider checked={transactionSelector} onChange={(event, data) => sliderToggled(event, data)} label="Expenses" style={{ paddingLeft: 10 }} />
                                    </div>
                                    {transactionSelector ?
                                        <div style={{ flex: 1, flexDirection: 'row', alignContent: 'flex-start', marginRight: 40 }}>
                                            {/* {transactionSelector ? */}
                                            {SearchExampleStandard(expenseSource)}
                                            {/* :
                                            SearchExampleStandard1(perkSource)
                                        } */}
                                        </div>
                                        :
                                        <div style={{ flex: 1, flexDirection: 'row', alignContent: 'flex-start', marginRight: 40 }}>
                                            {/* {transactionSelector ?
                                            SearchExampleStandard(expenseSource)
                                        : */}
                                            {SearchExampleStandard1(perkSource)}
                                            {/* } */}
                                        </div>
                                    }

                                </div>
                            </div>

                            {transactionSelector ?
                                expensesToDisplay.length ?
                                    <TransactionTableList onTransactionSelect={handleTransactionSelectionChange}
                                        transactions={expensesToDisplay}
                                        allTransactionsSelected={allTransactionSelection}
                                        onAllTransactionsToggle={e => setAllTransactionSelection(
                                            !allTransactionSelection)}
                                        handleReceiptClick={handleReceiptClick}
                                        ascending={ascending}
                                        handleDateChevron={handleDateChevron}
                                    />
                                    :
                                    <div>
                                        No Expense Transactions available.
                                </div>
                                :
                                perksToDisplay.length ?
                                    <PerkTransactionTableList transactions={perksToDisplay}
                                        ascending={ascending}
                                        handleDateChevron={handleDateChevron}
                                    />
                                    :
                                    <div>
                                        No Perk Transactions available.
                                </div>
                            }
                        </div>

                    </div>

                    {/* Modals for requesting receipts */}
                    <Modal dimmer={'blurring'} open={requestModal}
                        size="small" onClose={requestModalCloseHandler}>
                        <Modal.Content style={{ display: checkCount ? 'block' : 'none' }}>
                            <p>You are requesting that [{employee.name}] provide receipts for [{checkCount}] transactions.</p>
                        </Modal.Content>
                        <Modal.Actions className="center aligned">
                            <Button onClick={requestModalCloseHandler}>Cancel</Button>
                            <Button className="primary" content="Save"
                                onClick={requestModalConfirmHandler} />
                        </Modal.Actions>
                    </Modal>

                    <Modal dimmer={'blurring'} open={requestResponseModal} size="small" onClose={requestModalCloseHandler}>
                        {apiSuccess ?
                            <Modal.Content>
                                <Modal.Content style={{ display: selectedTransactions.length ? 'block' : 'none' }}>
                                    <p>[{selectedTransactions.length}] transaction(s) were successfully Requested for Receipts.</p>
                                </Modal.Content>
                                <Modal.Content style={{ display: remainder > 0 ? 'block' : 'none' }}>
                                    <p>Cannot Request [{remainder}] Transaction(s) for Receipts.</p>
                                </Modal.Content>
                            </Modal.Content>
                            :
                            <Modal.Content style={{ display: remainder > 0 ? 'block' : 'none' }}>
                                <p>There was some error. Please try again.</p>
                            </Modal.Content>
                        }
                        <Modal.Actions className="center aligned">
                            <Button className="primary" content="Close"
                                onClick={requestModalCloseHandler} />
                        </Modal.Actions>
                    </Modal>

                    {/* Modals for flagging transactions */}
                    <Modal dimmer={'blurring'} open={flagModal} size="small" onClose={flagModalCloseHandler}>
                        <Modal.Content style={{ display: checkCount ? 'block' : 'none' }}>
                            <p>You are Flagging [{checkCount}] Transaction(s).</p>
                        </Modal.Content>
                        <Modal.Actions className="center aligned">
                            <Button onClick={flagModalCloseHandler}>Cancel</Button>
                            <Button className="primary" content="Save"
                                onClick={flagModalConfirmHandler} />
                        </Modal.Actions>
                    </Modal>

                    <Modal dimmer={'blurring'} open={flagResponseModal} size="small" onClose={flagModalCloseHandler}>
                        {apiSuccess ?
                            <Modal.Content>
                                <Modal.Content style={{ display: selectedTransactions.length ? 'block' : 'none' }}>
                                    <p>[{selectedTransactions.length}] transaction(s) were successfully Flagged.</p>
                                </Modal.Content>
                                <Modal.Content style={{ display: remainder > 0 ? 'block' : 'none' }}>
                                    <p>Cannot Flag [{remainder}] Transaction(s).</p>
                                </Modal.Content>
                            </Modal.Content>
                            :
                            <Modal.Content style={{ display: remainder > 0 ? 'block' : 'none' }}>
                                <p>There was some error. Please try again.</p>
                            </Modal.Content>
                        }
                        <Modal.Actions className="center aligned">
                            <Button className="primary" content="Close"
                                onClick={flagModalCloseHandler} />
                        </Modal.Actions>
                    </Modal>

                    {/* Modals for approving transactions */}
                    <Modal dimmer={'blurring'} open={approveModal} size="small" onClose={approveModalCloseHandler}>
                        <Modal.Content style={{ display: checkCount ? 'block' : 'none' }}>
                            <p>You are Approving [{checkCount}] Transaction(s).</p>
                        </Modal.Content>
                        <Modal.Actions className="center aligned">
                            <Button onClick={approveModalCloseHandler}>Cancel</Button>
                            <Button className="primary" content="Save"
                                onClick={approveModalConfirmHandler} />
                        </Modal.Actions>
                    </Modal>

                    <Modal dimmer={'blurring'} open={deleteEmployeeModal} size="small" onClose={() => setDeleteEmployeeModal(false)}>
                        <Modal.Content style={{ display: 'block' }}>
                            <p style={{ fontSize: 18, color: '#FCC65C', fontStyle: 'SFProText-Medium' }}>WARNING!</p>
                            <p>You are trying to delete this employee.</p>
                            <p>Doing this will delete all employee data from the database</p>
                            <p>and indefinitely deactivate all (if any) cards under the employee.</p>
                        </Modal.Content>
                        <Modal.Actions className="center aligned">
                            <Button onClick={() => setDeleteEmployeeModal(false)}>Cancel</Button>
                            <Button className="primary" content="Save"
                                onClick={confirmDeleteEmployee} />
                        </Modal.Actions>
                    </Modal>

                    <Modal dimmer={'blurring'} open={approveResponseModal} size="small" onClose={approveModalCloseHandler}>
                        {apiSuccess ?
                            <Modal.Content>
                                <Modal.Content style={{ display: selectedTransactions.length ? 'block' : 'none' }}>
                                    <p>[{selectedTransactions.length}] transaction(s) were successfully Approved.</p>
                                </Modal.Content>
                                <Modal.Content style={{ display: remainder > 0 ? 'block' : 'none' }}>
                                    <p>Cannot Approve [{remainder}] Transaction(s).</p>
                                </Modal.Content>
                            </Modal.Content>
                            :
                            <Modal.Content style={{ display: remainder > 0 ? 'block' : 'none' }}>
                                <p>There was some error. Please try again.</p>
                            </Modal.Content>
                        }
                        <Modal.Actions className="center aligned">
                            <Button className="primary" content="Close"
                                onClick={approveModalCloseHandler} />
                        </Modal.Actions>
                    </Modal>

                    {/* {apiSuccess ?  */}
                    <Modal dimmer={'blurring'} open={receiptModal} size="small" onClose={receiptModalCloseHandler}>
                        {apiSuccess ?
                            <Modal.Content className="center aligned">
                                {selectedReceipt ?
                                    <p>
                                        <span>Merchant Name: {selectedReceipt.merchant}</span>
                                        <span style={{ paddingLeft: 10 }}>Date: {selectedReceipt.date}</span>
                                        <span style={{ paddingLeft: 10 }}>Category: {selectedReceipt.category}</span>
                                        <span style={{ paddingLeft: 10 }}>Amount: $ {selectedReceipt.amount / 100}</span>
                                    </p>
                                    : null}
                                {selectedReceipt ?
                                    <p>
                                        <span>Status: </span>
                                        <span style={{
                                            color: selectedReceipt.receiptStatus === "flaggedHR" ?
                                                "red"
                                                :
                                                selectedReceipt.receiptStatus === "requestedHR" ?
                                                    "yellow"
                                                    :
                                                    selectedReceipt.receiptStatus === "uploadedEmployee" ?
                                                        "blue"
                                                        :
                                                        "green"
                                        }}
                                        >
                                            {selectedReceipt.receiptStatus === "flaggedHR" ?
                                                "Flagged"
                                                :
                                                selectedReceipt.receiptStatus === "requestedHR" ?
                                                    "Requested"
                                                    :
                                                    selectedReceipt.receiptStatus === "uploadedEmployee" ?
                                                        "Uploaded by Employee"
                                                        :
                                                        "Approved"
                                            }
                                        </span>
                                        <span style={{ paddingLeft: 10 }}>Button Goes Here</span>
                                    </p>
                                    : null}
                            </Modal.Content>
                            : <Modal.Content className="center aligned">
                                <p>Some Error Occured. Please try again.</p>
                            </Modal.Content>}
                        {apiSuccess ?
                            <Modal.Content className="center aligned" style={{ width: '100%', paddingLeft: '20%', paddingRight: '20%' }}>
                                {/* <Modal.Content className="center aligned" style={{width: window.innerHeight * 9 / 13, paddingLeft: window.innerHeight * 9 / 78, backgroundColor: 'pink'}}> */}
                                <Carousel className="center aligned" showThumbs={false} style={{ width: '60%' }}>
                                    {receiptImages.map((receipt, index) => {
                                        return (
                                            <div key={index} className="center aligned">
                                                {/* <Image src={receipt} style={{height: window.innerHeight * 3 / 4, width: window.innerHeight * 9 / 15}} /> */}
                                                <Image src={receipt} style={{ width: '100%' }} />
                                            </div>
                                        )
                                    })}
                                </Carousel>
                            </Modal.Content>
                            :
                            null
                        }
                        <Modal.Actions className="center aligned">
                            <Button onClick={receiptModalCloseHandler}>Close</Button>
                        </Modal.Actions>
                    </Modal>

                    {/* --- page ends here --- */}
                </>
                : SearchExampleStandard([])}
        </div>
    )
}

